import { ArrangementType } from '@api';
import { Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import styles from './Arrangement.module.css';

const TRANS_PATH = 'PROJECTS_TABLE.ARRANGEMENT';

type ArrangementPropsType = {
  arrangement: ArrangementType;
};
export const Arrangement: React.FC<ArrangementPropsType> = ({
  arrangement,
}) => {
  const { t } = useTranslation('financeOverview');

  return (
    <Stack gap={0}>
      {arrangement.amount && (
        <Text className={styles.arrangement}>
          {t(`${TRANS_PATH}.AMOUNT`)}: {arrangement.amount}
        </Text>
      )}
      {arrangement.min && (
        <Text className={styles.arrangement}>
          {t(`${TRANS_PATH}.MIN`)}: {arrangement.min}
        </Text>
      )}
      {arrangement.max && (
        <Text className={styles.arrangement}>
          {t(`${TRANS_PATH}.MAX`)}: {arrangement.max}
        </Text>
      )}
    </Stack>
  );
};
